import { useEffect, useState } from 'react'

const useResponsiveSkeletonCount = ({ viewMode }: { viewMode: string }) => {
	const [skeletonCount, setSkeletonCount] = useState(12)

	useEffect(() => {
		const calculateSkeletonCount = () => {
			const width = window.innerWidth

			if (width >= 1280) {
				return viewMode === 'grid' ? 12 : 8
			} else if (width >= 1024) {
				return viewMode === 'grid' ? 8 : 6
			} else if (width >= 768) {
				return viewMode === 'grid' ? 8 : 4
			} else if (width >= 640) {
				return viewMode === 'grid' ? 6 : 4
			} else {
				return 4
			}
		}

		const updateSkeletonCount = () => {
			setSkeletonCount(calculateSkeletonCount())
		}

		updateSkeletonCount()
		window.addEventListener('resize', updateSkeletonCount)

		return () => {
			window.removeEventListener('resize', updateSkeletonCount)
		}
	}, [viewMode])

	return skeletonCount
}

export default useResponsiveSkeletonCount
